//FETCH QUESTIONS AND ANSWERS

export const FETCH_QUESTION_AND_ANSWERS_REQUEST="FETCH_QUESTION_AND_ANSWERS_REQUEST";
export const FETCH_QUESTION_AND_ANSWERS_SUCCESS="FETCH_QUESTION_AND_ANSWERS_SUCCESS";
export const FETCH_QUESTION_AND_ANSWERS_FAILURE="FETCH_QUESTION_AND_ANSWERS_FAILURE";